/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/no-danger */
import * as React from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Modal } from '../..';

type ModalProps = {
  onCloseModal: () => void;
  labelPrints: string;
};

function PrintBarcodeLabels({ onCloseModal, labelPrints }: ModalProps) {
  const componentRef = React.useRef(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      const getScrollHeight = (componentRef.current as any).contentWindow
        .document.body.scrollHeight;

      (componentRef.current as any).height = getScrollHeight;
    },
    onAfterPrint: () => onCloseModal(),
    pageStyle: 'div.label { break-inside: avoid; break-after: auto; }',
  });

  return (
    <Modal onClose={onCloseModal} show>
      <div className="rounded-md bg-white w-full tablet:!min-w-[350px] overflow-scroll relative min-h-[500px]">
        <div className="p-[10px] relative h-full flex flex-col">
          <div className="flex-1">
            <ComponentToPrint ref={componentRef} receiptHTML={labelPrints} />
          </div>
          <div className="flex flex-col items-center justify-center space-y-4 h-fit shrink-0 px-5 pt-5 pb-2">
            <Button
              label="Print"
              onClick={handlePrint}
              type="button"
              disabled={false}
              className="!bg-pos-green border border-[rgba(27,31,36,0.15)] !min-w-[150px]  h-[40px]
                      items-center justify-center text-white text-xbase
                      shadow-[0_1px_0_rgba(27,31,36,0.1),inset_0_1px_0_rgba(255,255,255,0.03)] shrink-0 font-medium"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

const ComponentToPrint = React.forwardRef<any, any>(
  ({ receiptHTML }: { receiptHTML: any }, ref) => {
    return (
      <iframe
        ref={ref}
        height={550}
        width="100%"
        onLoad={(event: any) => {
          if (event.target.style) {
            // console.log('Barcode', event.target.contentWindow);
            // eslint-disable-next-line no-param-reassign
            // event.target.style.width = `${event.target.contentWindow.document.documentElement.scrollWidth}px`;
            // eslint-disable-next-line no-param-reassign
            // event.target.style.width = '144px';
          }
        }}
        title="Barcode Labels"
        srcDoc={receiptHTML}
      />
    );
  },
);

export default PrintBarcodeLabels;
